<template>
  <div class="card card-rounded card-shadow border-0 mt-3 mt-lg-5 pb-0 pr-4 pr-lg-0 fade-in-up animation-delay card-with-watermark card-bg-translucent icon-watermark-lg-none">
    <div class="card-body">
      <div class="font-weight-bolder h3-lg mt-lg-n1 mb-lg-3">{{ $t('Banner.title') }}</div>
      <ul class="list-checked mt-1 mb-0">
        <li v-if="isLoanApplicationEnabled">{{ $t('Banner.item.1') }}</li>
        <li>{{ $t('Banner.item.2') }}</li>
        <li>{{ $t('Banner.item.3') }}</li>
      </ul>
      <div class="small text-muted">
        {{ $t('Banner.footnote')}}
      </div>
    </div>
    <Icon icon-name="iute-pepper-outline" icon-class="icon-watermark"></Icon>
  </div>
</template>

<script>
import settings from '@shared/settings'
import Icon from '@shared/components/Icon'

export default {
  components: { Icon },
  computed: {
    isLoanApplicationEnabled() {
      return settings.featureFlags.isLoanApplicationEnabled()
    }
  }
}
</script>
